import { Box, Button } from "@drone-js/core";
import { useParams } from "router";
import { useStaticDataAtomValue } from "../staticDataAtom";

export const CallToAction = () => {
    const {
        cmsData: {
            complete: { addNewListingText, manageListingText },
        },
    } = useStaticDataAtomValue();
    const { lang } = useParams("/:lang/list-my-property/onboard/:propertyId/complete");

    return (
        <Box display="flex" justifyContent="end" flexDirection="column-reverse" qM={{ flexDirection: "row" }}>
            <Box me="0" mt="16" qM={{ me: "16", mt: "0" }}>
                <Button
                    variant="label"
                    size="l"
                    hierarchy="secondary"
                    label={addNewListingText}
                    data-element-name="add-new-listing"
                    href={`/${lang}/list-my-property/get-started`}
                />
            </Box>
            <Button
                variant="label"
                size="l"
                hierarchy="secondary"
                data-element-name="manage-listing"
                label={manageListingText}
                href={`/homes/${lang}/HostManage/#/listings/inprogress`}
            />
        </Box>
    );
};
